import { EventInput } from '@fullcalendar/core';
import { CalendarEventModel } from '../../../../../../api-service/clients';
import { createBaseCalendarEventInput, parseEventDate } from './helpers';

export function mapBookingCalendarEvent(
  event: CalendarEventModel
): EventInput | null {
  const startDate = parseEventDate(event.startDate);
  const endDate = parseEventDate(event.endDate);
  if (!startDate || !endDate) {
    return null;
  }

  return {
    ...createBaseCalendarEventInput(event),
    start: startDate,
    end: endDate,
    allDay: false,
  };
}
